/**
 * 共通スクリプトのエントリ
 * jQuery / Splide をここで読み込み、window に渡してから各モジュールを実行
 */
import $ from 'jquery';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';
import 'magnific-popup/dist/magnific-popup.css';

window.$ = window.jQuery = $;
window.Splide = Splide;

import './scroll-restore.js';
import { init as smoothScrollInit } from './smoothScroll.js';
import { init as hamburgerInit } from './hamburger.js';
import { init as headerSpScrollInit } from './header-sp-scroll.js';
import { initHeaderNavSell } from './header-nav-sell.js';
import { init as splideInit } from './splide.js';
import { initMiraclasCardFade } from './miraclas-card-fade.js';
import { init as footerNavInit } from './footerNav.js';
import { init as breadcrumbsInit } from './breadcrumbs.js';
import { init as searchSelectInit } from './searchSelect.js';
import { init as staffTabsInit } from './staffTabs.js';
import { initVisitFlow } from './visit-flow.js';
import { initLoginFlow } from './login-flow.js';
import { initMemberRegisterFlow } from './member-register-flow.js';
import { initMemberEditFlow } from './member-edit-flow.js';
import { initMemberWithdrawalFlow } from './member-withdrawal-flow.js';
import { initDocumentRequestFlow } from './document-request-flow.js';
import { initPropertyRequestFlow } from './property-request-flow.js';
import { initContactInquiryFlow } from './contact-inquiry-flow.js';
import { initContactInquiryStaffFlow } from './contact-inquiry-staff-flow.js';
import { initVisitDatepickers } from './visit-datepicker.js';
import { initVisitSchedule } from './visit-schedule.js';
import { initBukkenDetailVisitSchedule } from './bukken-detail-visit-schedule.js';
import { initStoreDetailStaffBodyHeadMatchHeight } from './store-detail-staff-match.js';
import { initSpecialCardBodyMatchHeight } from './special-card-match.js';
import { initStaffRecommendCardMatchHeight } from './staff-recommend-card-match.js';
import { init as bukkenListFiltersInit } from './bukken-list-filters.js';
import { init as bukkenListAreaModalInit } from './bukken-list-area-modal.js';
import { initBukkenListAreaLabels } from './bukken-list-area-label.js';
import { init as bukkenDetailModalInit } from './bukken-detail-modal.js';
import { init as bukkenListFloorModalInit } from './bukken-list-floor-modal.js';
import { init as staffVoiceZoomModalInit } from './staff-voice-zoom-modal.js';
import { initSearchMapSidebar } from './search-map-sidebar.js';
import { init as topSearchTypeModalsInit } from './top-search-type-modals.js';
import { init as cardFigureAlignInit } from './card-figure-align.js';
import { initRangeSelectControls } from './range-select-control.js';
import { initTopIntroFallback } from './top-intro.js';

function initTopMvIntroFallback() {
	initTopIntroFallback();
}

function init() {
	initTopMvIntroFallback();
	smoothScrollInit();
	hamburgerInit();
	headerSpScrollInit();
	initHeaderNavSell();
	splideInit();
	initMiraclasCardFade();
	footerNavInit();
	breadcrumbsInit();
	searchSelectInit();
	staffTabsInit();
	initVisitDatepickers();
	initVisitFlow();
	initVisitSchedule();
	initBukkenDetailVisitSchedule();
	initLoginFlow();
	initMemberRegisterFlow();
	initMemberEditFlow();
	initMemberWithdrawalFlow();
	initDocumentRequestFlow();
	initPropertyRequestFlow();
	initContactInquiryFlow();
	initContactInquiryStaffFlow();
	initStoreDetailStaffBodyHeadMatchHeight();
	initSpecialCardBodyMatchHeight();
	initStaffRecommendCardMatchHeight();
	bukkenListFiltersInit();
	bukkenListAreaModalInit();
	initBukkenListAreaLabels();
	bukkenDetailModalInit();
	bukkenListFloorModalInit();
	staffVoiceZoomModalInit();
	initSearchMapSidebar();
	topSearchTypeModalsInit();
	cardFigureAlignInit();
	initRangeSelectControls();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
